<header class="site-header">
  <nav aria-label="social">
    <div class="top-links">
      <a href="mailto:ebubekir.elicora@gmx.de" aria-label="E-Mail" class="icon">
        <img
          class="base"
          src="assets/img/icons/social_media/eMail.svg"
          alt="Mail"
        />
        <img
          class="hover"
          src="assets/img/icons/social_media/eMail_hover.svg"
          alt=""
          aria-hidden="true"
        />
      </a>
      <a
        href="https://www.linkedin.com/in/ebubekir-eli%C3%A7ora-a27b47392/"
        target="_blank"
        rel="noopener"
        aria-label="LinkedIn"
        class="icon"
      >
        <img
          class="base"
          src="assets/img/icons/social_media/linkedIn.svg"
          alt="LinkedIn"
        />
        <img
          class="hover"
          src="assets/img/icons/social_media/linkedIn_hover.svg"
          alt=""
          aria-hidden="true"
        />
      </a>
      <a
        href="https://github.com/EbubekirElicora"
        target="_blank"
        rel="noopener"
        aria-label="GitHub"
        class="icon"
      >
        <img
          class="base"
          src="assets/img/icons/social_media/gitHub.svg"
          alt="GitHub"
        />
        <img
          class="hover"
          src="assets/img/icons/social_media/gitHub_hover.svg"
          alt=""
          aria-hidden="true"
        />
      </a>
    </div>
    <div class="lang code-regular">
      <a
        class="de"
        href="/de"
        lang="de"
        hreflang="de"
        (click)="setGerman(); $event.preventDefault()"
        >DE</a
      >

      <a
        class="en"
        href="/en"
        lang="en"
        hreflang="en"
        (click)="setEnglish(); $event.preventDefault()"
        >EN</a
      >
    </div>
  </nav>
</header>
